import { TAU, random } from '@CS/utils/Number';
import Particle from './Particle';

const ANGLE = 8.0;
const HALF_ANGLE = ANGLE / 2.0;

export default class Circle extends Particle {
  public constructor(context: CanvasRenderingContext2D) {
    super(context);
  }

  protected override setPosition(): void {
    this.position.x = random(0.0, this.width);
    this.position.y = ANGLE * -2.0;
  }

  protected override setDuration(): void {
    this.duration = random(10.0, 25.0);
  }

  protected override reset(): void {
    !Circle.DropOnce && super.reset();
  }

  public override draw(): void {
    super.draw(true);

    const alpha = this.opacity.toFixed(2.0);
    this.context.fillStyle = `rgba(${this.rgb}, ${alpha})`;
    this.context.arc(-HALF_ANGLE, -HALF_ANGLE, ANGLE, 0.0, TAU);

    this.context.fill();
    this.context.restore();
  }
}
